<template>
  <div class="status">
    <myDialog :logTitle="'案件状态'" :showDialog.sync="open">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close"/>
      <div class="main-content" v-loading="loading" :key="Date.now()">
        <Descriptions title="垫付状态" col="8">
          <description-item label="案件号">{{ applyStatus.caseId }}</description-item>
          <description-item label="费用类型">{{
              dictMap.road_rescue_apply_fee_type[applyStatus.applyFeeType]
            }}
          </description-item>
          <description-item label="审核人用户账号">{{ applyStatus.approveUserName }}</description-item>
          <description-item label="支付时间">{{ applyStatus.giveMoneyTime }}</description-item>
          <description-item label="垫付金额">{{ applyStatus.adjustmentMoney }}</description-item>
          <description-item label="退回原因">{{ applyStatus.returnReason }}</description-item>
        </Descriptions>
        <Descriptions title="案件状态" col="24">
        </Descriptions>
        <el-steps :space="200" :active="activeSqxxState" finish-status="success" style="margin-bottom: 15px">
          <el-step v-for="item in sqxxState" :title="item.label"></el-step>
        </el-steps>
        <Descriptions title="审核状态" col="24">
        </Descriptions>
        <el-steps :space="200" :active="activeApproveState" finish-status="success">
          <el-step v-for="item in approveState" :title="item.label"></el-step>
        </el-steps>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'
import Descriptions from "@/components/Description/Descriptions";
import {getApplyStatus} from "@/api/rescue/roadRescue";
import {getDictMap} from "@/utils/dict/dictData";

export default {
  name: 'RoadRescueFundDetail',
  components: {myDialog, Descriptions},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    caseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      dictMap: {
        road_rescue_apply_fee_type: {},
        road_rescue_wechat_sqxx_state: {},
        road_rescue_wechat_approve_state: {},
      },
      sqxxState: [{
        value: "2067001", label: "受理"
      }, {
        value: "2067002", label: "审核"
      }, {
        value: "2067003", label: "复核"
      }, {
        value: "2067004", label: "支付成功"
      }, {
        value: "2067005", label: "不予垫付"
      }],
      activeSqxxState: 0,
      approveState: [{
        value: "2068001", label: "待审核"
      }, {
        value: "2068002", label: "审核通过"
      }, {
        value: "2068003", label: "退回修改"
      }, {
        value: "2068004", label: "已失效"
      }],
      activeApproveState: 0,
      applyStatus: {
        caseId: '',
        wechatSqxxState: '',
        approveUserName: '',
        giveMoneyTime: '',
        applyFeeType: '',
        adjustmentMoney: '',
        wechatApproveState: '',
        returnReason: '',
        fileList: [{
          fileId: '',
          fileName: '',
        }]
      },
    }
  },
  created() {
    getDictMap(this.dictMap).then(data => {
      this.dictMap = data;
    });
    this.init();
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    init() {
      this.loading = true;
      getApplyStatus(this.caseId).then(resp => {
          this.applyStatus = resp.data;
          this.setActive(this.applyStatus.wechatSqxxState, this.applyStatus.wechatApproveState);
          this.loading = false;
        }
      );
    },
    setActive(wechatSqxxState, wechatApproveState) {
      this.sqxxState.forEach((item, index) => {
        if (item.value === wechatSqxxState) {
          this.activeSqxxState = index;
        }
      });
      this.approveState.forEach((item, index) => {
        if (item.value === wechatApproveState) {
          this.activeApproveState = index;
        }
      });
    }
  }
}
</script>

<style lang="scss">
.status {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 80%;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .title {
      font-size: 20px;
    }
  }

  .el-step__title.is-process {
    font-weight: bold;
    color: #17ECFE;
  }

  .el-step__head.is-process {
    color: #17ECFE;
  }
}

</style>>
